import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fields", "template"]

  connect() {
    const template_fields = this.templateTarget.querySelectorAll('input, textarea, select');

    template_fields.forEach(field => {
      field.removeAttribute('required');
    });
  }

  add(event) {        
    event.preventDefault()
    const time = new Date().getTime()

    const content = this.templateTarget.innerHTML.replace(/new_faq_related_page/g, time)

    this.fieldsTarget.insertAdjacentHTML('beforeend', content)

    const fields = this.fieldsTarget.querySelectorAll('input, textarea, select');
    fields.forEach(field => {
      field.setAttribute('required', true);
    });
  }


  remove(event) {
    event.preventDefault()
    const relatedPageContainer = event.target.closest(".faq-related-pages-fields")
    const destroyField = relatedPageContainer.querySelector('[data-faq-related-pages-target="destroyField"]')

    const fields = relatedPageContainer.querySelectorAll('input, textarea, select');

    fields.forEach(field => {
      field.removeAttribute('required');
    });

    destroyField.value = "1"
    relatedPageContainer.style.display = "none"
  }
}